// extracted by mini-css-extract-plugin
module.exports = {"main-component":"executePopupCostBudget_main-component__1zHgT"};